import { render, staticRenderFns } from "./Addcategory.vue?vue&type=template&id=d638ecd6&lang=html"
import script from "./Addcategory.vue?vue&type=script&lang=js"
export * from "./Addcategory.vue?vue&type=script&lang=js"
import style0 from "./Addcategory.vue?vue&type=style&index=0&id=d638ecd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports